module.exports = __webpack_public_path__ + "static/img/check.8b1a55f7.svg";